export default __webpack_public_path__ + "static/media/title_th_pc.bad4e439.png";